import React from 'react';

// `modern` swaps only the spinner itself for the dark-screen version
// (.modernLoader in site-global.css); the overlay stays exactly as it is.
function RotatingLoader({ dark, text, background, colour, modern }) {
  return (
    <div className="theFiexedWidth" style={background ? { background } : {}}>
      <div className="loader-container">
        <div className="textUnder">
          <div className={modern ? 'modernLoader' : 'rotatingloader'} />
          <p className="loaderText" style={colour ? { color: colour } : {}}>{text}</p>
        </div>
      </div>
    </div>
  );
}

export default RotatingLoader;
